import { string } from 'prop-types';

import { ReactComponent as InfoIcon } from 'assets/icons/info.svg';
import Tooltip from 'components/common/Tooltip';

import { Counter, Text, HelpInfo } from './styles';

const CounterInfo = ({ label, message }) => (
  <Counter>
    <Text>{label}</Text>
    {message && (
      <>
        <InfoIcon data-tooltip-id="info-tooltip" />
        <Tooltip id="info-tooltip" place="top" variant="light">
          <HelpInfo>{message}</HelpInfo>
        </Tooltip>
      </>
    )}
  </Counter>
);

CounterInfo.propTypes = {
  label: string.isRequired,
  message: string
};

export default CounterInfo;
